interface SEOHeadProps {
  title: string;
  description: string;
  canonicalPath: string;
  ogType?: 'website' | 'article';
  ogImage?: string;
  keywords?: string;
  jsonLd?: Record<string, unknown>[];
}

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://mulebuyspreadsheets.beauty';

export default function SEOHead({
  title,
  description,
  canonicalPath,
  ogType = 'website',
  ogImage,
  keywords,
  jsonLd,
}: SEOHeadProps) {
  const canonicalUrl = `${SITE_URL}${canonicalPath}`;
  const defaultKeywords =
    'mulebuy spreadsheet, mulebuy spreadsheet list, mulebuy agents spreadsheet, mulebuy shopping spreadsheet, mulebuy spreadsheet guide, china agent spreadsheet';

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={ogType} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {jsonLd &&
        jsonLd.map((ld, i) => (
          <script
            key={i}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }}
          />
        ))}
    </>
  );
}